// Shared ICD-10-CM formatter. EMR exports disagree about the decimal: some send
// "F3341", some "F33.41", and the same practice can produce both across two files.
// Normalize on the way out so the ledger never shows the two spellings side by side.
//
// The decimal always sits after the third character in ICD-10-CM — category is three
// characters, everything after it is the subclassification. A bare three-character code
// (I10, F32) is complete on its own and takes no decimal at all.
export function formatIcd10(code) {
  if (code === null || code === undefined) return '';
  const bare = String(code).trim().toUpperCase().replace(/[.\s]/g, '');
  if (bare.length <= 3) return bare;
  return bare.slice(0, 3) + '.' + bare.slice(3);
}

// Comma-separated, in the order the claim carries them — the first is the primary
// diagnosis, and re-sorting would quietly change what the claim says.
export function formatIcd10List(codes) {
  if (!Array.isArray(codes)) return '';
  return codes.filter(Boolean).map(formatIcd10).join(', ');
}
